/**
 * Módulos disponibles en el sistema
 * Centralizados para mejor mantenimiento y consistencia
 */
export const AVAILABLE_MODULES = [
  {
    id: 'bulk_update',
    name: 'Actualización Masiva',
    code: 'bulk_update',
    icon: 'ri-upload-2-line',
    description: 'Realizar actualizaciones masivas de datos',
    category: 'data',
    route: { name: 'ActualizacionMasiva' }
  },
  {
    id: 'bulk_update_v2',
    name: 'Actualización Masiva V2',
    code: 'bulk_update_v2',
    icon: 'ri-upload-2-fill',
    description: 'Nueva versión de actualizaciones masivas de datos',
    category: 'data',
    route: { name: 'ActualizacionMasivav2' }
  },
  {
    id: 'bulk_loads',
    name: 'Cargas Másivas',
    code: 'bulk_loads',
    icon: 'ri-upload-cloud-line',
    description: 'Gestión de cargas masivas de datos',
    category: 'data',
    route: { name: 'CargasMasivasV2' }
  },
  {
    id: '4task',
    name: '4Task',
    code: '4task',
    icon: 'ri-task-line',
    description: 'Gestión de tareas y proyectos',
    category: 'tools',
    route: { name: '4Task' }
  },
  {
    id: 'master_4tool',
    name: 'Master 4Tool',
    code: 'master_4tool',
    icon: 'ri-tools-fill',
    description: 'Herramienta maestra para gestión avanzada',
    category: 'tools',
    route: { name: 'Master4Tool' }
  },
  {
    id: 'delete_records',
    name: 'Borrado Registros',
    code: 'delete_records',
    icon: 'ri-delete-bin-line',
    description: 'Gestión de borrado de registros',
    category: 'data',
    danger: true,
    route: { name: 'BorradoRegistros' }
  },
  {
    id: 'cargar_export',
    name: 'Cargar Export',
    code: 'cargar_export',
    icon: 'ri-upload-line',
    description: 'Carga y gestión de archivos de exportación',
    category: 'data',
    route: { name: 'CargarExport' }
  },
  {
    id: 'activity',
    name: 'Actividad',
    code: 'activity',
    icon: 'ri-line-chart-line',
    description: 'Monitoreo y registro de actividad del sistema',
    category: 'monitoring',
    route: { name: 'Activity' }
  },
  {
    id: 'permisos_4tool',
    name: 'Permisos 4Tool',
    code: 'permisos_4tool',
    icon: 'ri-shield-user-line',
    description: 'Gestión de permisos y roles del sistema 4Tool',
    category: 'admin',
    route: { name: 'Permisos4Tool' }
  },
  {
    id: 'panel_admin',
    name: 'Panel Admin',
    code: 'panel_admin',
    icon: 'ri-admin-line',
    description: 'Panel de administración general',
    category: 'admin',
    superuser: true,
    route: { name: 'PanelAdmin' }
  },
  {
    id: 'users',
    name: 'Usuarios',
    code: 'users',
    icon: 'ri-user-settings-line',
    description: 'Gestión de usuarios y permisos',
    category: 'admin',
    route: { name: 'Users' }
  }
]

/**
 * Categorías de módulos para organización visual
 */
export const MODULE_CATEGORIES = {
  data: {
    name: 'Gestión de Datos',
    color: '#28a745',
    icon: 'ri-database-line'
  },
  tools: {
    name: 'Herramientas',
    color: '#6f42c1',
    icon: 'ri-tools-line'
  },
  monitoring: {
    name: 'Monitoreo',
    color: '#20c997',
    icon: 'ri-bar-chart-line'
  },
  admin: {
    name: 'Administración',
    color: '#dc3545',
    icon: 'ri-admin-line'
  }
}

/**
 * Configuración de permisos por defecto
 */
export const DEFAULT_PERMISSIONS = {
  // Permisos básicos que todo usuario debería tener
  basic: ['activity'],

  // Permisos para usuarios estándar
  standard: ['activity'],

  // Permisos para administradores
  admin: [
    'bulk_update',
    'bulk_loads',
    'cargar_export',
    'activity',
    'users'
  ],
  
  // Permisos para superadministradores
  superadmin: 'all' // Todos los módulos
}

/**
 * Utilidades para trabajar con módulos
 */
export const moduleUtils = {
  /**
   * Obtener módulo por ID
   */
  getModuleById(id) {
    return AVAILABLE_MODULES.find(module => module.id === id)
  },

  /**
   * Obtener módulos por categoría
   */
  getModulesByCategory(category) {
    return AVAILABLE_MODULES.filter(module => module.category === category)
  },

  /**
   * Obtener módulos peligrosos
   */
  getDangerousModules() {
    return AVAILABLE_MODULES.filter(module => module.danger)
  },

  /**
   * Obtener módulos que requieren superusuario
   */
  getSuperuserModules() {
    return AVAILABLE_MODULES.filter(module => module.superuser)
  },

  /**
   * Validar si un conjunto de permisos es válido
   */
  validatePermissions(permissions) {
    if (!Array.isArray(permissions)) return false
    
    return permissions.every(permission => 
      AVAILABLE_MODULES.some(module => module.id === permission)
    )
  },

  /**
   * Obtener permisos por defecto según rol
   */
  getDefaultPermissions(role = 'basic') {
    const defaults = DEFAULT_PERMISSIONS[role]
    
    if (defaults === 'all') {
      return AVAILABLE_MODULES.map(module => module.id)
    }
    
    return defaults || DEFAULT_PERMISSIONS.basic
  },

  /**
   * Agrupar módulos por categoría
   */
  getModulesGroupedByCategory() {
    const grouped = {}
    
    AVAILABLE_MODULES.forEach(module => {
      if (!grouped[module.category]) {
        grouped[module.category] = []
      }
      grouped[module.category].push(module)
    })
    
    return grouped
  }
}